export default "__VITE_ASSET__DMWxQLU6__"